//------------- COMPONENT MENU HEADER ---------

//barra de header pertencente a todas as páginas do portal
//onde estão:
// - a barra de pesquisa geral
// - botão de notificações
// - botão de perfil para alterar senha
// - logo mosaic

//a barra de pesquisa precisará ser implementada de forma a pesquisar por páginas do portal
//ex: pesquisar Rotas, irá aparecer um dropdown redirecionando para as rotas
//caso tenha outra ideia, é muito bem-vinda

//botão de notificações ainda precisa ser implementado
//provavelmente será primariamente para usuários técnicos, que vão receber alertas
//sobre alterações no seu calendario de rotas

//apague esses comentarios quando terminar as tarefas kkkkkk

//importações
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";

import toast, { Toaster } from "react-hot-toast";

import { Link } from "react-router-dom";

import InputSearch from "../inpt-search";

import handleProfilePic from "../../utils/functions/profilePic";

//icons
import { BsBellFill } from "react-icons/bs";
import { BsFillPersonFill } from "react-icons/bs";

//assets
import MosaicLogo from "../../assets/logos/mosaic-black-logo.png";
import Requests from "../../services/requests";

import ReactLoading from "react-loading";

//component
const MenuHeader = ({ token, notif = true }) => {
  const navigate = useNavigate();
  const [user] = useState(JSON.parse(sessionStorage.getItem("user"))); // usuário atual do portal
  const [profileOpen, setProfileOpen] = useState(false); //verifica se o popup de perfil está aberto
  const [editPass, setEditPass] = useState(false); //verifica se o popup de editar senha está aberto

  //states para alteração de senha
  const [senhaAntiga, setSenhaAntiga] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [loading, setLoading] = useState(false);

  const clearForm = () => {
    setNovaSenha("");
    setSenhaAntiga("");
  };

  //gerencia a troca de senha
  const handleChangePass = async (e) => {
    e.preventDefault();

    setLoading(true);

    if (novaSenha === senhaAntiga) {
      toast.error("A nova senha deve ser diferente da senha antiga");
      setLoading(false);
    } else if (novaSenha.length < 4) {
      toast.error("A nova senha deve conter pelo menos 4 caracteres");
      setLoading(false);
    } else {
      let config = { headers: { "x-access-token": token } };
      let object = {
        email: user.email,
        senhaAntiga: senhaAntiga,
        novaSenha: novaSenha,
      };
      await Requests.putNovaSenha(object, config, () => {})
        .then((res) => {
          if (res.mensagem === "Senha alterada com sucesso!") {
            toast.success("Senha editada com sucesso!");
            sessionStorage.removeItem("token");
            setLoading(false);
            setEditPass(false);
            clearForm();
            let path = "/";
            navigate(path);
          } else {
            toast.error("Não foi possível editar a senha");
          }
        })
        .catch((err) => {
          toast.error("Não foi possível editar a senha");
        });
    }
  };

  //view do component
  return (
    <div className="div-header-menu">
      <div>
        <Toaster />
      </div>
      <div className="div-tool-bar">
        {/* botão de perfil do usuário */}
        <div className="header-item">
          <div
            className="profile-icon"
            onClick={() => {
              setProfileOpen(!profileOpen);
              setEditPass(false);
            }}
          >
            <p>{handleProfilePic(user)}</p>
          </div>
          <div
            className="person-icon-div"
            onClick={() => {
              setProfileOpen(!profileOpen);
              setEditPass(false);
            }}
          >
            <BsFillPersonFill className="person-icon"></BsFillPersonFill>
          </div>
          {user && (
            <div
              className="profile-name"
              onClick={() => {
                setProfileOpen(!profileOpen);
                setEditPass(false);
              }}
            >
              <p className="nome">{user.nome ? user.nome : "nome"}</p>
              <p className="tipo">{user.tipo ? user.tipo : "tipo"}</p>
            </div>
          )}
          {profileOpen && !editPass && (
            <div className="bubble bubble-bottom-left">
              <p>{user.email ? user.email : "email"}</p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                }}
              >
                <p
                  style={{ margin: 0, marginLeft: "-25%" }}
                  onClick={() => {
                    sessionStorage.removeItem("token");
                    let path = "/";
                    navigate(path);
                  }}
                >
                  Logout
                </p>
                <p
                  style={{ margin: 0, marginRight: "-25%" }}
                  onClick={() => {
                    setEditPass(true);
                  }}
                >
                  Alterar Senha
                </p>
              </div>
            </div>
          )}
          {profileOpen && editPass && (
            <div className="bubble bubble-bottom-left">
              <form onSubmit={handleChangePass}>
                <p>Senha Antiga*</p>
                <input
                  required
                  id="senha"
                  name="senha"
                  value={senhaAntiga}
                  onChange={(e) => {
                    setSenhaAntiga(e.target.value);
                  }}
                  placeholder="Senha Antiga"
                  type={"password"}
                ></input>
                <p>Nova Senha*</p>
                <input
                  required
                  id="rsenha"
                  name="rsenha"
                  value={novaSenha}
                  onChange={(e) => {
                    setNovaSenha(e.target.value);
                  }}
                  placeholder="Nova Senha"
                  type={"password"}
                ></input>
                {loading ? (
                  <ReactLoading color="#00544d" height={50} width={50} />
                ) : (
                  <button>Confirmar</button>
                )}
              </form>
            </div>
          )}
        </div>
        <Link className="btn-link" to="/home">
          <img alt="logo Mosaic" src={MosaicLogo}></img>
        </Link>
      </div>
    </div>
  );
};

export default MenuHeader;
